<template>
    <BModal id="des-modal"
            v-bind:no-close-on-backdrop=true
            dialogClass="modal-dialog-left modal-lg"
            bodyClass="p-3" v-model="modalShow" size="xl">
        <template #header>
            <h2>
                Email
            </h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect
                waves-themed" v-on:click="modalShow = !modalShow">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <template #title>
            Email
        </template>
        
        <div class="description pl-1 pl-1">
            <BTabs content-class="mt-3">
                <BTab title="Лист" active>
                    
                    <h2>Підписалися (Вибрано {{selected_users.length}})</h2>
                    
                    <QuillEditor
                        v-model:content="email"
                        contentType="html"
                        theme="snow"
                        :toolbar="editor_rules"
                        placeholder="Введіть опис…"
                        class="tender-editor"
                    />
                </BTab>
                
                <BTab title="Користувачі">
                    <p>
                        <BButton class="mr-3" variant="outline-primary" size="sm" @click="selectAllSub">Всі</BButton>
                        <BButton size="sm" @click="clearSelectedSub">Очистити</BButton>
                    </p>
                    
                    <BTable
                        ref="invitations"
                        selectable
                        select-mode="multi"
                        primary-key="user_id"
                        @update:selected-items="onSelectedItems"
                        striped
                        :items="items"
                        :fields="fields"
                        show-empty
                    >
                
                    <template #cell(selected)="{ rowSelected }">
                        <span aria-hidden="true">{{ rowSelected ? '✓' : '' }}</span>
                    </template>
                    </BTable>
                    
                    <!--
                    <BTable
                        @row-selected="onRowSelectedsub"
                        ref="invitations"
                        selectable striped
                        :items="items"
                        :fields="fields"
                        show-empty
                    >
                        <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                                <span aria-hidden="true">&check;</span>
                                <span class="sr-only">Selected</span>
                            </template>
                            <template v-else>
                                <span aria-hidden="true">&nbsp;</span>
                                <span class="sr-only">Not selected</span>
                            </template>
                        </template>
                    </BTable>
                    -->
                    
                </BTab>
            </BTabs>
        </div>
        
        <template #footer>
            <div  class="main_buttons">
                <BButton  :disabled="!canSend" size="lg" class="me-2" variant="primary" @click="sendEmail">
                    Надіслати
                </BButton>
            </div>
        </template>
    </BModal>
</template>

<script>


import { BModal, BButton ,BOverlay,BTabs,BTab,BTable} from 'bootstrap-vue-next';
import { QuillEditor } from '@vueup/vue-quill';
export default {
    name: "tender_letter",
    components: {
        BModal,
        BOverlay,
        QuillEditor,
        BTabs,
        BTab,
        BButton,
        BTable
    },
    
    emits: ['update:show', 'update:email', 'send'],
    
    props : {
        tender_id : {
            type : Number,
            required : true
        }
    },
    
    data() {
        return {
            editor_rules: [
                ['bold', 'italic', 'underline', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['clean'] // по желанию (ластик)
            ],
            fields : [
                { key: 'selected', label: '', class: 'text-center', thStyle: { width: '32px' } },
               // { key: 'user_id', label: 'ID' },
                { key: 'email', label: 'Email'  },
                { key: 'edrpou', label: 'ЄДРПОУ'  },
                { key: 'contact_tel', label: 'Телефон'  },
                { key: 'company', label: 'Контрагент'  },
            ],
            is_load : false,
            modalShow : false,
            email: "",
            items : [],
            selected_users : [],
        }
    },
    
    created() {
        EventBus.$on('show_email_tender',this.show_email_send);
        this.loadSubscribers();
    },
    
    methods: {
        selectAllSub() {
            this.$refs.invitations.selectAllRows();
        },
        
        onSelectedItems(items) {
            this.selected_users = items
        },
        
        clearSelectedSub() {
            this.$refs.invitations.clearSelected()
        },
        
        async loadSubscribers() {
            this.is_load = true;
            this.items = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender_id) + "/inside/subscribes").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        close() {
            this.modalShow = false;
            this.text = '';
            this.title = '';
            this.selected_users = [];
        },
        
        show_email_send() {
            this.selected_users = [];
            this.email = '';
            this.modalShow = true;
        },
        
        sendEmail() {
            if(this.canSend) {
                this.$emit('send', this.email,this.selected_users)
                this.modalShow = false;
            }
        }
    },
    
    computed: {
        canSend() {
            return this.email.length > 10 && this.selected_users.length > 0;
        },
    },
}
</script>


<style scoped>

</style>